import { Transform } from 'stream'

/**
 * Allows a custom node to be appended at the top of a tree.
 *
 * Usage:
 *
 *	this.stream = new TopLevelNode({
 *		id: 'my-id',
 *		icon: 'icon-name',
 *		label: 'my label'
 *	}).pipeToStream(stream)
 *
 *	// When options is clicked, call the select/add method within the view
 *	this.treeActions.on('selected', this.select.bind(this))
 *
 */
class TopLevelNode {
	constructor(options = {}) {
		this.options = options
	}

	addToStream (stream) {
		let transform = new Transform({objectMode: true})
		let first = true
		let id = this.options.id
		let label = this.options.label
		let icon =  this.options.icon
		transform._transform = function (node, enc, next) {
			if (first) {
				first = false
				this.push({id, label, type: icon, organizationId: node.organizationId })
			}
			this.push(node)
			next()
		}
		return stream.pipe(transform)
	}
}

export default TopLevelNode


TopLevelNode.__filename__ = 'components/top-level-node.js'
